export default __webpack_public_path__ + "static/media/x-box-image-detail-4.a3b73233.png";